module.exports = require("@openworklabs/lotus-jsonrpc-engine");